export const dateRangesAu = [
  {
    monthKey: "januaryEscapeSentence",
    month: 1,
    years: {
      2021: "1X2021",
      2022: "1X2022",
    },
  },
  {
    monthKey: "februaryEscapeSentence",
    month: 2,
    years: {
      2021: "2X2021",
      2022: "2X2022",
    },
  },
  {
    monthKey: "marchEscapeSentence",
    month: 3,
    years: {
      2021: "3X2021",
      2022: "3X2022",
    },
  },
  {
    monthKey: "aprilEscapeSentence",
    month: 4,
    years: {
      2021: "4X2021",
      2022: "4X2022",
    },
  },
  {
    monthKey: "mayEscapeSentence",
    month: 5,
    years: {
      2021: "5X2021",
      2022: "5X2022",
    },
  },
  {
    monthKey: "juneEscapeSentence",
    month: 6,
    years: {
      2021: "6X2021",
      2022: "6X2022",
    },
  },
  {
    monthKey: "julyEscapeSentence",
    month: 7,
    years: {
      2021: "7X2021",
      2022: "7X2022",
    },
  },
  {
    monthKey: "augustEscapeSentence",
    month: 8,
    years: {
      2021: "8X2021",
      2022: "8X2022",
    },
  },
  {
    monthKey: "septemberEscapeSentence",
    month: 9,
    years: {
      2020: "9X2020",
      2021: "9X2021",
      2022: "9X2022",
    },
  },
  {
    monthKey: "octoberEscapeSentence",
    month: 10,
    years: {
      2020: "10X2020",
      2021: "10X2021",
      2022: "10X2022",
    },
  },
  {
    monthKey: "novemberEscapeSentence",
    month: 11,
    years: {
      2020: "11X2020",
      2021: "11X2021",
      2022: "11X2022",
    },
  },
  {
    monthKey: "decemberEscapeSentence",
    month: 12,
    years: {
      2020: "12X2020",
      2021: "12X2021",
      2022: "12X2022",
    },
  },
];
